import { Component, OnInit } from '@angular/core';
import { ViewUploadedDocumentComponent } from 'src/app/shared/components/view-uploaded-document/view-uploaded-document.component';

@Component({
    selector: 'app-dqf-view-document',
    templateUrl: './dqf-view-document.component.html',
    styleUrls: ['./dqf-view-document.component.scss'],
    standalone: true,
    imports: [ViewUploadedDocumentComponent]
})
export class DqfViewDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
